import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export const PricingSection = () => {
  return <section id="pricing" className="py-32 px-4 relative overflow-hidden" data-id="element-147">
      <div className="absolute inset-0 bg-radial-gold opacity-30 pointer-events-none" data-id="element-148"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-149">
        <FadeIn data-id="element-150">
          <div className="bg-parchment border-2 border-gold/30 rounded-3xl p-8 md:p-16 text-center relative shadow-[0_0_50px_rgba(184,146,46,0.1)]" data-id="element-151">
            {/* Top accent */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-parchment px-6 py-2 border border-gold/30 rounded-full" data-id="element-152">
              <span className="text-gold-antique font-semibold tracking-wider uppercase text-sm" data-id="element-153">
                Precio de Lanzamiento
              </span>
            </div>

            <h2 className="font-playfair text-3xl md:text-4xl font-bold text-brown-heading mb-6 mt-4" data-id="element-154">
              Es el momento de dejar de observar la sombra y empezar a diseñar
              la luz.
            </h2>

            <p className="text-lg text-brown-warm/60 mb-12" data-id="element-155">
              No necesitas años de búsqueda; necesitas la tecnología correcta
              para tu conciencia.
            </p>

            <div className="mb-12" data-id="element-156">
              <span className="text-2xl text-brown-warm/40 line-through mr-4" data-id="element-157">
                $27.00
              </span>
              <span className="text-6xl md:text-7xl font-bold gold-gradient-text font-playfair" data-id="element-158">
                $6.39
              </span>
              <span className="text-xl text-brown-warm/60 ml-2" data-id="element-159">USD</span>
              <p className="mt-3 text-sm text-gold-antique/70 font-medium tracking-wide uppercase" data-id="element-160">
                Descuento por tiempo limitado
              </p>
            </div>

            <Button className="w-full md:w-auto text-lg md:text-xl px-12 py-5" data-id="element-161">
              RECLAMAR MI RENACER AHORA
            </Button>

            <p className="mt-6 text-sm text-brown-warm/50" data-id="element-162">
              Acceso inmediato y de por vida.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};